import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        navList: [], //顶部导航
        navBanner: [], //页面banner一一对应
        cate: [], //二级菜单
    },
    mutations: {
        initNavData(state,data){
            state.navList = data.navList;
            state.navBanner = data.navBanner;
            state.cate = data.cate;
            console.log(state.navList);
            console.log(state.navBanner);
            console.log(state.cate);
        }
    },
    actions: {

    }
})